import { Injectable } from '@angular/core';

@Injectable()
export class TestService {
  _test: string;
  constructor() {
    this._test = 'helo';
  }

  get test() {
    return this._test;
  }

  set test(val) {
    this._test = val;
  }
}
